const takeDefaultConstants = {
  defaultSpecialCourseId: {},
  defaultSpecialCourseIdsInSubscription: {
    17329: 17082
  },
  defaultPaywallServiceId: 343,
  defaultLinkQuiz: 'https://takeclass.io/course/tc_eng_school_up_s_quiz',
  coursesForShowModalNewOffer: [17329],
  coursesForHideModalNewOffer: [17082]
}

export default takeDefaultConstants
